import HorizontalLine from "./HorizontalLine";

export * from ".";
export default HorizontalLine;